import * as t from 'io-ts';

import type { CheckBoxDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface DateRangeSettingDefinition extends CheckBoxDefinition {
    key: 'DATE_RANGE';
}

const definition: DateRangeSettingDefinition = {
    key: 'DATE_RANGE',
    type: 'CheckBox',
    label: 'Date range',
    value: false,
    scope: 'designer',
};

export const specSettingsInterface = createSpecSettingsInterface(definition, t.boolean);

export const codec = specSettingsInterface.input;

export const DateRangeSettingDefinition = define({
    key: 'DATE_RANGE',
    label: 'dateRange',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.dateRange),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.dateRange),
});
